import React from 'react';
import MatchRow from './MatchRow';
import IconImg from './IconImg';
import { EVT } from '../../data/homeData';

export default function SportSection({ section, green = false }) {
  return (
    <div className="card">
      <div className="card-body card-content p-0">
        <div className={`bet-table-header${green ? ' green-title' : ''}`}>
          <div className="row align-items-center">
            <div className="col-md-6">
              <span className="list-sport-title">
                <IconImg className="img-fluid game-icon-img" src={`${EVT}/menu-${section.iconId}.png`} /> {section.title}
              </span>
              <ul className="ks-cboxtags">
                <li><input type="checkbox" id={`live-${section.key}`} /><label htmlFor={`live-${section.key}`}>LIVE</label></li>
                <li><input type="checkbox" id={`virt-${section.key}`} /><label htmlFor={`virt-${section.key}`}>VIRTUAL</label></li>
                <li><input type="checkbox" id={`prem-${section.key}`} /><label htmlFor={`prem-${section.key}`}>PREMIUM</label></li>
              </ul>
            </div>
            <div className="col-md-2 text-center d-none d-md-block"><small>1</small></div>
            <div className="col-md-2 text-center d-none d-md-block"><small>X</small></div>
            <div className="col-md-2 text-center d-none d-md-block"><small>2</small></div>
          </div>
        </div>
        <div className="bet-table-body">
          {section.rows.map((r, i) => <MatchRow key={i} row={r} />)}
        </div>
      </div>
    </div>
  );
}
